import React from 'react';
import { useSelector } from 'react-redux';
import { Banner } from 'Features/MyAccount/PromoBanner/Banner';

export const PromoBannerContainer = ({ promoBanner, useDetailsBanner, handleClickBanner = null }) => {
  const { routes } = useSelector((s) => s.appConfig);
  const bannerImage = useDetailsBanner ? promoBanner.promotionDetailsBanner : promoBanner.banner;
  const planId = promoBanner.bannerSKU;
  const bannerLink = planId ? `${routes.payment}/${planId}` : null;
  const promoCode = promoBanner.promoCode;

  return (
    <Banner
      image={bannerImage}
      className={promoBanner.className}
      bannerLink={bannerLink}
      promoCode={promoCode}
      planId={planId}
      handleClickBanner={handleClickBanner}
    ></Banner>
  );
};
